import { useMemo } from 'react';

import { useFeatureFlag } from '@/modules/featureFlags/useFeatureFlag';

import { presentationIncrementalSaveStrategy } from './incremental/presentationIncrementalSaveStrategy';
import { presentationFullWriteStrategy } from './presentationFullWriteStrategy_deprecated';
import { PresentationSaveStrategy } from './presentationSave.types';

/**
 * The single place the designer decides how a save is written, so no component,
 * descriptor or util needs a flag check.
 *
 * One strategy, not a preferred one with a fallback: a change the diff-based save
 * cannot express is dropped rather than escalated. See T1-6071.
 */
export function usePresentationSaveStrategy(): PresentationSaveStrategy {
  const isIncrementalSaveEnabled = useFeatureFlag('presentation_stable_save');

  return useMemo(
    () =>
      isIncrementalSaveEnabled
        ? presentationIncrementalSaveStrategy()
        : presentationFullWriteStrategy(),
    [isIncrementalSaveEnabled]
  );
}
